import $ from 'jquery';

/**
 * @plugin calfilters
 * @desc Adds filters to the calendar events grid view.
 * */

const pluginName = 'calfilters';
const defaults = {
  defaultFilter: null,
  filters: undefined,
  quantity: 0,
};

function CalFilters(element, options) {
  this.element = element;
  this.$calendar = $(element);
  this.$name = pluginName;
  this.$defaults = defaults;
  this.options = Object.assign({}, defaults, options);
  this.addFilters = this.addFilters.bind(this);
  this.$filters = this.render('filters');
  this.addFilters();
  this.init();
}

CalFilters.prototype = {
  init() {
    const plugin = this;
    plugin.$filters.find(`a.show-${plugin.currentFilter}`).click();
  },
  /**
   * Controls the assignment of the current calendar filter
   *
   * @returns {string}
   */
  getCurrentFilter() {
    // get saved calendar filter if it exists in sessionStorage.
    const plugin = this;
    const { filters } = plugin.options;
    const defaultFilter = plugin.getDefaultFilter();
    let currentFilter = sessionStorage.getItem('calfilters.currentFilter');

    // if the saved filter wasn't found or is invalid, set the current filter
    // to the default filter provided
    if (!currentFilter || !Object.prototype.hasOwnProperty.call(filters, currentFilter)) {
      currentFilter = defaultFilter;
    }
    return currentFilter;
  },
  /**
   * Controls the assignment of the default calendar filter
   *
   * @returns {string}
   */
  getDefaultFilter() {
    const plugin = this;
    const { filters } = plugin.options;
    let { defaultFilter } = plugin.options;

    // if a default filter was assigned, validate if it's a property of the
    // filters object
    if (defaultFilter && !Object.prototype.hasOwnProperty.call(filters, defaultFilter)) {
      // notify the user that an invalid default filter was passed
      alert(`[calfilter] An invalid default calendar filter ('${defaultFilter}') has been passed to the calfilters js plugin.`);
      // invalid default filter passed, eliminate it
      defaultFilter = null;
    }

    // set the default filter (to the first property of the filters object)
    // if it wasn't passed or is invalid
    if (!defaultFilter) {
      const keys = [];
      $.each(filters, (k) => {
        keys.push(k);
      });
      [defaultFilter] = keys;
    }
    return defaultFilter;
  },
  tabClicked(event) {
    const plugin = event.data.scope;
    const filter = event.data.value;
    plugin.$filters.find('a.active').removeClass('active');
    $(this).addClass('active');
    plugin.$calendar.find(`.node:visible:not(.wt${filter})`).slideUp();
    plugin.$calendar.find(`.node.wt${filter}`).slideDown();
    // store the current filter to persist through different calendar views.
    sessionStorage.setItem('calfilters.currentFilter', filter);
    plugin.currentFilter = filter;
    event.preventDefault();
  },
  render(name, args) {
    const plugin = this;
    const templates = {
      filters() {
        const $filters = $('<div class="filters"></div>');
        let activeSet = false;
        $.each(plugin.options.filters, (filter, value) => {
          let filterClasses = 'filter';
          if (!activeSet) {
            filterClasses += ' active';
            activeSet = true;
          }
          if (plugin.$calendar.find('.node').hasClass(`wt${value}`)) {
            $filters.append(`<a class="${filterClasses} show-${value}">${filter}</a>`);
            $filters.find(`.show-${value}`).bind('click', { scope: plugin, value }, plugin.tabClicked);
            plugin.options.quantity += 1;
          }
        });
        return $filters;
      },
    };
    // return a rendered template.
    return templates[name](args);
  },

  createDropdown() {
    return '<h3 class="ctrl">Filter by...</h3>';
  },

  addListener() {
    this.$createDropdown.insertBefore(this.$calendar.find('.filters'));
    this.$createDropdown.bind('click', this.filterHandler);
  },

  filterHandler(event) {
    event.preventDefault();
    $(this).next('.filters').toggleClass('expanded');
  },

  addFilters() {
    if (this.options.quantity > 1) {
      this.$filters.insertBefore(this.$calendar.find('.calendar-heading .date-nav'));
      this.$createDropdown = $(this.createDropdown());
      this.addListener();
    }
  },
};

// $.fn[pluginName] = (options) => {
//   const temp = this.each(() => {
//     if (!$.data(this, `plugin_${pluginName}`)) {
//       $.data(this, `plugin_${pluginName}`, new Plugin(this, options));
//     }
//   });
//   return temp;
// };

export default CalFilters;
